export default __webpack_public_path__ + "static/prosandcons2-955e215d81495e424cdfd7613b66f8f3.png";